import Vue from 'vue';

const success = response => response.data;

const error = () => {};

export default () => Vue.$http
    .get('users/count')
    .then(success)
    .catch(error);



// WEBPACK FOOTER //
// ./src/services/user/countAll.js